import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAIXIgEnRiWp3R6EcAb3Q_Wj0zujjt8H8I",
  authDomain: "zimetafsiriwa-a48e1.firebaseapp.com",
  projectId: "zimetafsiriwa-a48e1",
  storageBucket: "zimetafsiriwa-a48e1.firebasestorage.app",
  messagingSenderId: "833843210804",
  appId: "1:833843210804:web:65757a5882dc2860ec3861"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
